import React from 'react';
import styled from '@emotion/styled';
import { Spacings, mediaQuery } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import { useRouter } from 'next/router';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${Spacings.SPACING_6B};
  margin: auto;
  position: relative;
  width: var(--layout-width);
  ${mediaQuery.uptoTablet} {
    width: 100%;
    padding: 0 ${Spacings.SPACING_8B};
  }
  ${mediaQuery.uptoMobile} {
    width: 100%;
    padding: 0 ${Spacings.SPACING_4B};
  }
  margin-top: ${Spacings.SPACING_6B};
`;
const OffersContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoMobile} {
    width: 100%;
  }
`;
const OffersAvailable = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: ${Spacings.SPACING_6B};

  ${mediaQuery.uptoMobile} {
    width: 100%;
    overflow: scroll;
    overscroll-behavior: unset;

    ::-webkit-scrollbar {
      display: none;
    }
  }
`;
const OfferInfo = styled.a`
  position: relative;
  overflow: hidden;
  width: 240px;
  height: 64px;
  background-color: var(--color-background);
  border-radius: ${Spacings.SPACING_2};
  justify-content: center;
  gap: ${Spacings.SPACING_1B};
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  padding-left: ${Spacings.SPACING_6B};
  cursor: pointer;
`;
const ProofMarker = styled.div`
  position: absolute;
  width: 12px;
  aspect-ratio: 1;
  border-radius: 50%;
  border-top: 1px solid #f4eee0;
  border-right: 1px solid #f4eee0;
  background-color: var(--color-base-1);

  :nth-of-type(1) {
    top: 20%;
    left: 0;
    transform: translateX(-50%) rotate(45deg);
  }
  :nth-of-type(2) {
    bottom: 20%;
    left: 0;
    transform: translateX(-50%) rotate(45deg);
  }
  :nth-of-type(3) {
    top: 20%;
    right: 0;
    transform: translateX(50%) rotate(-45deg);
  }
  :nth-of-type(4) {
    bottom: 20%;
    right: 0;
    transform: translateX(50%) rotate(-45deg);
  }
`;

const getSortedData = (cardData) => {
  const sortedData = {};
  cardData.forEach((card) => {
    if (
      !sortedData[card.allowedDurationDays] ||
      sortedData[card.allowedDurationDays].offeredDurationDays <
        card.offeredDurationDays
    )
      sortedData[card.allowedDurationDays] = card;
  });
  return Object.values(sortedData);
};

const SubscriptionOffers = (props) => {
  const { data: cardData } = props;
  const {
    query: { goalSlug, goalUID }
  } = useRouter();
  if (cardData.length === 0) return null;
  const sortedData = getSortedData(cardData);
  return (
    <Container>
      <OffersContainer>
        <Typography variant="h6">ONGOING OFFERS</Typography>
        <OffersAvailable>
          {sortedData.map((offer) => (
            <OfferInfo
              key={`key-${offer.uid}`}
              href={`/goal/${goalSlug}/${goalUID}/offers`}
            >
              <ProofMarker />
              <ProofMarker />
              <ProofMarker />
              <ProofMarker />
              <Typography variant="h6" color="var(--color-text-primary)">
                Upto {offer.offeredDuration} extra
              </Typography>
              <Typography variant="p3" color="#A9742A">
                With {offer.allowedDuration} subscription
              </Typography>
            </OfferInfo>
          ))}
        </OffersAvailable>
      </OffersContainer>
    </Container>
  );
};
export default SubscriptionOffers;
